// MoreMenuBottomSheet component for Admin/Director mobile navigation
// CREATED: Bottom sheet menu for secondary navigation items on mobile
// Shows Utilisateurs, Sites, Services, Missions with icons

import { BottomSheet } from '../ui/BottomSheet';
import { moreMenuItems } from '../../lib/navigationConfig';

interface MoreMenuBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (path: string) => void;
  currentPath: string;
}

export function MoreMenuBottomSheet({ isOpen, onClose, onNavigate, currentPath }: MoreMenuBottomSheetProps) {
  const handleItemClick = (path: string) => {
    onNavigate(path);
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Plus d'options"
    >
      <div className="py-2">
        {moreMenuItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.path;

          return (
            <button
              key={item.path}
              onClick={() => handleItemClick(item.path)}
              className={`w-full flex items-center gap-4 px-6 py-3.5 min-h-[48px] transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon className={`w-6 h-6 ${isActive ? 'text-blue-600' : 'text-gray-500'}`} />
              <span className={`text-base font-medium ${isActive ? 'text-blue-600' : 'text-gray-900'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
}
